<template>
  <div>
    <QS-h4-title title="网约运营信息">
      <template slot="right">
        网约运营流水:{{(+operation.amount).toFixed(2) }}元
        </template>
    </QS-h4-title>
    <template>
      <div class="box-container">
        <div class="box-content">
          <div class="box-label">运营流水: </div>
          <el-input class="box-val" v-model="operation.amount" placeholder="请输入" @input="(val) => moneyBlur(val)">
            <template slot="append">元</template>
          </el-input>
        </div>
        <div class="box-content">
          <div class="box-label">备注: </div>
          <el-input class="box-val box-textarea" v-model="operation.remark" type="textarea" placeholder="请输入备注"
            maxlength="500" show-word-limit>
          </el-input>
        </div>
      </div>
      <div class="box-container">
        <div class="box-content">
          <div class="box-label">备注图片: </div>
          <div class="box-upload ml16">
            <UploadCommon
              :fileList="operation.photos"
              :isAlone="false" :isShowTitle="false"
              :limit="3"
              :showUploadBtnByLimit="3"
              :sizeType="4"
              group="order"
              code="order_operation_information_note_pic"
              commonUpload
            >
            </UploadCommon>
          </div>
        </div>
      </div>
    </template>
  </div>

</template>
<script>
import { limitMoreZero } from '@/utils/validate'

export default {
  data() {
    return {
      operation: {
        amount: '0.00',
        remark: '',
        photos: [],
      },
    }
  },
  inject: ['settleDetail'],
  watch: {
    settleDetail: {
      handler() {
        this.setData()
      },
    },
  },
  methods: {
    moneyBlur(value) {
      const self = this
      limitMoreZero(value, (res) => {
        self.operation.amount = res
        self.$emit('operationSumChange', res)
      }, 7)
    },
    setData() {
      this.operation.amount = this.settleDetail.operationFlowAmount
      this.operation.remark = this.settleDetail.operationFlowRemarks
      this.operation.photos = Array.isArray(this.settleDetail.operationFlowPhotos) ? this.settleDetail.operationFlowPhotos : this.getURL({ data: this.settleDetail.operationFlowPhotos, defaultImg: [], needName: true })
      this.$emit('operationSumChange', this.operation.amount)
    },
    // 处理提交需要的数据
    // eslint-disable-next-line vue/no-unused-properties
    getData() {
      return {
        operationFlowAmount: this.operation.amount || 0,
        operationFlowRemarks: this.operation.remark || '',
        operationFlowPhotos: this.getUoloadCommonFileData(this.operation.photos),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.box-container {
  display: flex;
}

.box-content {
  display: flex;
  margin-bottom: 16px;

  .box-label {
    width: 150px;
    flex: 0 0 auto;
    padding-right: 10px;
    color: #333333;
    text-align: right;
  }

  .box-val {
    display: flex;
    min-width: 200px;
    word-break: break-all;
    ::v-deep .el-input-group__append {
      line-height: 32px;
      height: 32px;
      width: auto;
      padding: 0 10px;
    }
  }

  .box-textarea {
    width: 300px
  }

  .box-photos {
    display: flex;
    flex-wrap: wrap;

    .item {
      margin-left: 16px;
      width: 80px;
      height: 80px;

      &:nth-child(5n + 1) {
        margin-left: 0;
      }

      &:nth-child(n + 6) {
        margin-top: 30px;
      }
    }
  }
}
</style>
